import React, { useEffect, useState } from "react";
import { PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, EditOutlined, ExpandAltOutlined } from '@ant-design/icons';
import { Modal, Col, Row, Table, Space, Button, Form, FormInstance, Select, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { AlignType } from 'rc-table/lib/interface';

import { errorMessage } from "../../../utils/messages";
import { disabledDate } from "../../../utils/utilsFunctions";
import { IPepSituacao, ISituacaoPepPessoaFisica } from "./InterfacePessoaFisica";

interface IProps {
  form: FormInstance<any>;
  pessoaFisicaPepSituacoes: ISituacaoPepPessoaFisica[];
  setPessoaFisicaPepSituacoes: React.Dispatch<React.SetStateAction<ISituacaoPepPessoaFisica[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar / 9 :  Histórico;
  pepSituacoes: IPepSituacao[];
}

const { Option } = Select;
const PessoaFisicaSituacao = ({ form, pessoaFisicaPepSituacoes, setPessoaFisicaPepSituacoes, manter, pepSituacoes }: IProps) => {
  const [estadoModal, setEstadoModal] = useState(1); // 1 : Modal em modo inserção / 2 : Modal em modo detalhe /  3 : Modal em modo edição
  const [exibirModalPfSituacao, setExibirModalPfSituacao] = useState(false);
  const [exibirSituacaoCadastrado, setExibirSituacaoCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");

  useEffect(() => {
    if (pessoaFisicaPepSituacoes && pessoaFisicaPepSituacoes.length === 0) {
      setExibirSituacaoCadastrado("none")
    } else {
      setExibirSituacaoCadastrado("inline")
    }
  }, [pessoaFisicaPepSituacoes]);

  useEffect(() => {
    if (manter === 2 || manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);

  useEffect(() => {
    if (estadoModal === 3) { // EM EDIÇÃO
      controleDaGrid("editar"); // PASSA O MODAL PARA O MODO EDIÇÃO
    } else if (estadoModal === 2) { // EXIBIR DETALHES
      controleDaGrid("detalhar"); // CONFIGURA MODAL PARA ABRIR
    }
  }, [estadoModal])


  const controleDaGrid = (botao: string) => {

    if (botao === "cancelar") {
      setExibirModalPfSituacao(false);
      setExibirElementoAcaoAlteracao("inline");
    } else if (botao === "incluir") {
      setExibirModalPfSituacao(false);
      setExibirElementoAcaoAlteracao("inline");
    } else {
      setExibirModalPfSituacao(true);
      setExibirElementoAcaoAlteracao("none");
    }

    if (manter === 2 ||  manter === 9) { // Detalhar / Histórico
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarSituacao = () => {
    form
      .validateFields([
        "dtSituacao",
        "dtFim",
        "idPepSituacao",
        "nomePepSituacao",
      ])
      .then(() => {
        controleDaGrid("incluir");
        setDadosSituacao();
        // successMessage("Situacão Adicionada");
        // successMessage(estadoModal === 3 ? "Situação de Pessoa Exposta Politicamente Alterada" : "Situação de Pessoa Exposta Politicamente Adicionada");

      })
      .catch((error) => {
        errorMessage("Campo obrigatório não preechido");
      });
  };

  function setDadosSituacao() {
    if (estadoModal === 3) { // ESTADO EDIÇÃO DE REGISTROS
      setPessoaFisicaPepSituacoes(pre => {
        return pre.map(pep => {
          if (pep.emEdicao) {
            return ({
              idPessoaFisicaPepSituacao: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaPepSituacao")) : -1,
              idPepSituacao: form?.getFieldValue("idPepSituacao"),
              nomePepSituacao: form?.getFieldValue("nomePepSituacao").toUpperCase(),
              dtSituacao: form?.getFieldValue("dtSituacao") ? dayjs(form?.getFieldValue("dtSituacao")).format("YYYY-MM-DD") : "",
              dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
              statusReg: 1,
              touched: true,
              emEdicao: false,
            })
          } else {
            return pep
          }
        })
      });
    } else {
      setPessoaFisicaPepSituacoes([
        ...pessoaFisicaPepSituacoes,
        {
          idPessoaFisicaPepSituacao: estadoModal === 3 ? Number(form?.getFieldValue("idPessoaFisicaPepSituacao")) : -1,
          idPepSituacao: form?.getFieldValue("idPepSituacao"),
          nomePepSituacao: form?.getFieldValue("nomePepSituacao").toUpperCase(),
          dtSituacao: form?.getFieldValue("dtSituacao") ? dayjs(form?.getFieldValue("dtSituacao")).format("YYYY-MM-DD") : "",
          dtFim: form?.getFieldValue("dtFim") ? dayjs(form?.getFieldValue("dtFim")).format("YYYY-MM-DD") : "",
          statusReg: 1,
          emEdicao: false,
          touched: true,
        },
      ]);
    }

    form.resetFields([
      "dtSituacao",
      "dtFim",
      "idPepSituacao",
      "nomePepSituacao",
    ]);
    setEstadoModal(1); // SETA O MODAL PARA INCLUSÃO (MODO PADRÃO).
  }

  const handlerPepSituacao = async (value: any) => {
    form.setFieldsValue({
      nomePepSituacao: value.children,
      idPepSituacao: value.key,
    });
  };

  const setFieldsDetalharEditar = (ISituacao: ISituacaoPepPessoaFisica) => {
    form.setFieldsValue({
      "idPessoaFisicaPepSituacao": ISituacao.idPessoaFisicaPepSituacao,

      "idPepSituacao": ISituacao.idPepSituacao,
      "nomePepSituacao": ISituacao.pepSituacao && ISituacao.pepSituacao.nmPepSituacao ? ISituacao.pepSituacao.nmPepSituacao : ISituacao.nomePepSituacao,

      "dtSituacao": ISituacao.dtSituacao ? dayjs(ISituacao.dtSituacao) : undefined,
      "dtFim": ISituacao.dtFim ? dayjs(ISituacao.dtFim) : undefined,
    });
  }


  const columns = [
    {
      // width: 200,
      key: "1",
      title: "Situacao",
      dataIndex: "",
      render: (ISituacao: ISituacaoPepPessoaFisica) => <>{ISituacao.pepSituacao && ISituacao.pepSituacao.nmPepSituacao ? (ISituacao.pepSituacao.nmPepSituacao).toUpperCase() : ISituacao.nomePepSituacao?.toUpperCase()}</>,
    },
    {
      // width: 200,
      key: "2",
      title: "Data da Situacao",
      dataIndex: "",
      render: (ISituacao: ISituacaoPepPessoaFisica) => <>{dayjs(ISituacao.dtSituacao).format("DD/MM/YYYY")}</>,
    },
    {
      // width: 200,
      key: "1",
      title: "Data Fim da Situacao",
      dataIndex: "",
      render: (ISituacao: ISituacaoPepPessoaFisica) => <>{ISituacao.dtFim ? dayjs(ISituacao.dtFim).format("DD/MM/YYYY") : "ATUAL"}</>,
    },
    {
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (ISituacao: ISituacaoPepPessoaFisica) => (
          <Space style={{justifyContent: 'center'}}>
            <div style={{ display: manter === 2 ||  manter === 9 ? "inline" : "none" }}>
              <ExpandAltOutlined
                title="Detalhar"
                style={{ color: "blue", marginLeft: 12 }}
                onClick={() => {
                  setEstadoModal(2); // SET O MODO DETALHAR
                  setFieldsDetalharEditar(ISituacao);
                }}
              />
            </div>

            <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
              <Space style={{justifyContent: 'center'}}>
                <EditOutlined
                  title="Editar"
                  style={{ color: "blue", marginLeft: 12 }}
                  onClick={() => {
                    console.log(pessoaFisicaPepSituacoes)
                    setEstadoModal(3); // SET O MODO EDIÇÃO
                    setFieldsDetalharEditar(ISituacao);
                    // ALTERA CAMPOS DO DATASET PARA REFLETIR O ESTADO DE EDIÇÃO
                    pessoaFisicaPepSituacoes.forEach(pep => {
                      if (pep === ISituacao) {
                        pep.statusReg = 1;
                        pep.touched = true;
                        pep.emEdicao = estadoModal === 3 ? true : false;
                      } else {
                        pep.emEdicao = false;
                      }
                    })
                    ISituacao.emEdicao = true;
                  }}
                />

                <DeleteOutlined
                  title="Exluir registro não salvo na base"
                  style={{ color: "red", display: (ISituacao?.idPessoaFisicaPepSituacao && ISituacao?.idPessoaFisicaPepSituacao < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
                  onClick={() => {
                    setPessoaFisicaPepSituacoes(pessoaFisicaPepSituacoes.filter((situacao) => situacao !== ISituacao));
                  }}
                />
              </Space>
            </div>

          </Space>
      ),
    },

  ];

  const handleCancel = () => {
    setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
    controleDaGrid("cancelar");
    form.resetFields([
      "dtSituacao",
      "dtFim",
      "idPepSituacao",
      "nomePepSituacao"
    ]);

  }


  return (
    <>
      <Button
        style={{ display: exibirElementoAcaoAlteracao }}
        id="incluirSituacao"
        type="primary"
        shape="round"
        onClick={() => {
          setEstadoModal(1); // COLOCA O MODAL EM ESTADO DE INCLUSÃO DE NOVO REGISTRO.
          controleDaGrid("incluirSituacao");
        }}
        icon={<PlusOutlined />}
      >
        Incluir Situação
      </Button>

      <>

        <Modal title="Situação PEP" open={exibirModalPfSituacao}
          style={{ top: 20 }}
          width={750}
          destroyOnHidden={true}
          closable={false}
          footer={[
            <Button icon={<CloseOutlined />} shape="round" key="cancelFechar" onClick={handleCancel}>
              {estadoModal === 2 ? "Fechar" : "Cancelar"}
            </Button>,
            <Button icon={<CheckOutlined />} shape="round" style={{ display: estadoModal === 2 ? "none" : "inline" }}
              key="ok" type="primary" onClick={validarSituacao}>
              {estadoModal === 3 ? "Alterar" : "Incluir"}
            </Button>,
          ]}
        >
          <Row>
            <Col xs={24} sm={24}>
              <Form.Item label="Situacao"
                labelCol={{ span: 24 }}
                labelAlign="left"
                name="nomePepSituacao"
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "A situacao é obrigatória",
                  },
                ]}
              >
                <Select
                  showSearch
                  filterOption
                  optionFilterProp='children'
                  placeholder='Tipo'
                  onChange={(_, index) => {
                    handlerPepSituacao(index);
                  }}
                  disabled={estadoModal === 2}
                >
                  {pepSituacoes?.map((e: IPepSituacao) => (
                    <Option key={e.idPepSituacao} value={e.idPepSituacao} >
                      {e.nmPepSituacao}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col xs={24} sm={8}>
              <Form.Item label='Data de Início da Situação'
                name='dtSituacao'
                colon={false}
                rules={[
                  {
                    required: true,
                    message: "Selecione uma data válida",
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  disabledDate={disabledDate}
                  style={{ width: "100%" }}
                  placeholder="Data Início"
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={8}>
              <Form.Item label='Data Fim da Situação'
                name='dtFim'
                colon={false}
                rules={[
                  {
                    validator: async (_, endDatetime) => {
                      let startDatetime = form.getFieldValue("dtSituacao");
                      if (endDatetime && endDatetime){
                        if (startDatetime) {
                          if (endDatetime <= startDatetime) {
                            return Promise.reject(
                              "Data fim deve ser maior do que a data de início da situação."
                            );
                          }
                        }
                      }
                    },
                  },
                ]}
              >
                <DatePicker
                  format={"DD/MM/YYYY"}
                  style={{ width: "100%" }}
                  placeholder="Data Fim"
                  disabled={estadoModal === 2}
                />
              </Form.Item>
            </Col>

          </Row>
        </Modal>

      </>

      <Row style={{ display: exibirSituacaoCadastrado }}>
        <Col
          xs={24}
          sm={24}
          style={{ paddingLeft: 16, paddingRight: 16, marginBottom: 20 }}
        >
          <Table size="small" columns={columns} dataSource={pessoaFisicaPepSituacoes} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default PessoaFisicaSituacao;